import Vue from "vue";
import VueRouter from "vue-router";
import { auth } from "@/firebase";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "GreenShade",
    component: () =>
      import(/* webpackChunkName: "landing" */ "@/views/Landing.vue"),
  },
  {
    path: "/explore",
    name: "GreenShade",
    component: () =>
      import(/* webpackChunkName: "landing" */ "@/views/Explore.vue"),
  },
  {
    path: "/features",
    name: "GreenShade",
    component: () =>
      import(/* webpackChunkName: "landing" */ "@/views/Features.vue"),
  },
  {
    path: "/home",
    name: "Home",
    component: () => import(/* webpackChunkName: "home" */ "@/views/Home.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/settings",
    name: "Settings",
    component: () =>
      import(/* webpackChunkName: "settings" */ "@/views/Settings.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/monday-boardview-inventory",
    name: "GreenShade",
    component: () =>
      import(/* webpackChunkName: "monday-boardview-inventory" */ "@/views/BoardView_Inventory.vue"),
    // meta: {
    //   requiresAuth: true,
    // },
  },
  {
    path: "/monday-dashboardview-pools",
    name: "GreenShade",
    component: () =>
      import(/* webpackChunkName: "monday-dashboardview-pools" */ "@/views/DashboardView_Pools.vue"),
    // meta: {
    //   requiresAuth: true,
    // },
  },
  {
    path: "/create-pool",
    name: "GreenShade",
    component: () =>
      import(/* webpackChunkName: "create-pool" */ "@/views/Create_Pool.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/demo-board",
    name: "GreenShade Demo Board",
    component: () =>
      import(/* webpackChunkName: "demo-board" */ "@/views/BoardView_Inventory.vue"),
    // meta: {
    //   requiresAuth: true,
    // },
  },
  {
    path: "/demo-dashboard",
    name: "GreenShade Demo Dashboard",
    component: () =>
      import(/* webpackChunkName: "demo-dashboard" */ "@/views/DashboardView_Pools.vue"),
    // meta: {
    //   requiresAuth: true,
    // },
  },
  {
    path: "/payment-success",
    name: "PaymentSuccess",
    component: () =>
      import(/* webpackChunkName: "payment-success" */ "@/views/PaymentSuccess.vue"),
  },
  {
    path: "/payment-cancel",
    name: "PaymentCancel",
    component: () =>
      import(/* webpackChunkName: "payment-cancel" */ "@/views/PaymentCancel.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((x) => x.meta.requiresAuth);

  if (requiresAuth && !auth.currentUser) {
    next("/login");
  } else {
    next();
  }
});

export default router;
